// Angular
import {computed, Injectable, signal} from '@angular/core';

// App types
import type {PrefixResult} from '@app/core/interfaces/prefix-result.interface';

@Injectable()
export class PrefixStoreService {
  readonly prefixes = signal<PrefixResult | null>(null);

  readonly allPrefixes = computed(() => this.getPrefixes());

  setPrefixes(data: PrefixResult): void {
    this.prefixes.set(data);
  }

  reset(): void {
    this.prefixes.set(null);
  }

  getPrefixes(operators?: string[]): string[] {
    const data = this.prefixes();
    if (!data) {
      return [];
    }
    if (operators?.length) {
      return operators.flatMap(key => data[key as keyof PrefixResult] ?? []);
    }
    return Object.values(data).flat();
  }
}
